<template>
    <div>
        <MAModal
            v-if="store__showEditModal"
            id="dashboard-modal"
            :class="(store__lockButtons) ? `hide-close` : null"
            title="Edit Data Source"
            @close="store__toggleEditModal()"
        >
            <!-- Description Step -->
            <div
                slot="content"
                class="data-uploader-modal"
            >
                <MASpinner v-if="store__isLoading" />
                <div class="slds-grid slds-p-around_medium">
                    <div class="slds-size_1-of-1 slds-small-size_1-of-2">
                        <div class="slds-form-element slds-m-bottom_medium">
                            <MAInput
                                v-model="store__datasetToEdit.datasetLabel"
                                :isRequired="true"
                                label="Name"
                                class="slds-form-element"
                            />
                        </div>
                        <div class="slds-form-element slds-m-bottom_medium">
                            <MAInput
                                v-model="store__datasetToEdit.datasetDescription"
                                :isRequired="false"
                                label="Description"
                                class="slds-form-element"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Description Step -->

            <!-- Description Step Footer-->
            <div
                slot="footer"
                class="slds-grid slds-grid_align-end"
            >
                <button
                    class="slds-button slds-button_brand"
                    :disabled="store__lockButtons"
                    @click="checkDescriptionsInputs()"
                >
                    Save
                </button>
            </div>
            <!-- End Description Step Footer-->
        </MAModal>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import MAModal from '@mapanything/ma-lib/src/vue/components/MAModal.vue';
import MAInput from '@mapanything/ma-lib/src/vue/components/MAInput.vue';
import MASpinner from '@mapanything/ma-lib/src/vue/components/MASpinner.vue';

export default {
    name: 'Dashboard',
    components: {
        MAModal,
        MAInput,
        MASpinner
    },
    data() {
        return {
            datasets: []
        };
    },
    computed: {
        ...mapState({
            store__loginState: 'loginState',
            store__isLoading: 'isLoading',
            store__lockButtons: 'lockButtons',
            store__datasetToEdit: 'datasetToEdit',
            store__showEditModal: 'showEditModal'
        })
    },
    methods: {
        ...mapMutations({
            store__toggleEditModal: 'toggleEditModal',
            store__toggleSpinner: 'toggleSpinner',
            store__toggleLockButtons: 'toggleLockButtons'
        }),
        /* Checks that all required input fields are filled */
        checkDescriptionsInputs() {
            if (this.store__datasetToEdit.datasetLabel === '') {
                const toastMessage = {
                    showCloseButton: true,
                    type: 'error',
                    title: 'Missing Required Inputs',
                    body: 'Dataset Name is required',
                    timeout: 5000
                };

                this.$vueOnToast.pop(toastMessage);
            } else if (this.store__datasetToEdit.organizationIds === '') {
                const toastMessage = {
                    showCloseButton: true,
                    type: 'error',
                    title: 'Missing Required Inputs',
                    body: 'You must provide at least one org ID',
                    timeout: 5000
                };

                this.$vueOnToast.pop(toastMessage);
            } else {
                this.postDescriptionChanges()
                .catch((err) => {
                    throw err;
                });
            }
        },
        /* POST request to test schema */
        postDescriptionChanges() {
            return new Promise((resolve, reject) => {
                const API_URL = document.location.href;
                let datasetDescription;

                if (this.store__datasetToEdit.datasetDescription) {
                    datasetDescription = (this.store__datasetToEdit.datasetDescription.trim() === '') ? null : this.store__datasetToEdit.datasetDescription;
                }

                const postBody = {
                    datasetID: this.store__datasetToEdit.datasetID,
                    datasetLabel: this.store__datasetToEdit.datasetLabel,
                    datasetDescription
                };

                // Begin loading spinner...
                this.store__toggleSpinner();
                // Lock Save Button...
                this.store__toggleLockButtons();

                this.$http.put(`${API_URL}api/dataset`, postBody)
                .then((res) => {
                    if (res.status === 200) {
                        const toastMessage = {
                            showCloseButton: true,
                            type: 'success',
                            title: 'Success',
                            body: 'Dataset Updated',
                            timeout: 5000
                        };

                        this.$vueOnToast.pop(toastMessage);

                        resolve(res);
                    } else {
                        const toastMessage = {
                            showCloseButton: true,
                            type: 'error',
                            title: 'Server Error',
                            body: 'There was an issue updating your dataset',
                            timeout: 5000
                        };

                        this.$vueOnToast.pop(toastMessage);
                        reject(res);
                    }
                })
                .catch((err) => {
                    console.log('err', err);
                    const toastMessage = {
                        showCloseButton: true,
                        type: 'error',
                        title: 'Error Contacting Server',
                        body: 'There was an issue contacting the server to update your dataset',
                        timeout: 5000
                    };

                    this.$vueOnToast.pop(toastMessage);
                    reject(err);
                })
                .finally(() => {
                    // End loading spinner...
                    this.store__toggleSpinner();
                    // Unlock Save Button...
                    this.store__toggleLockButtons();
                    // Hide Modal...
                    this.store__toggleEditModal();
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    .slds-pill__icon_container .slds-icon {
        display: flex;
        justify-content: center;
    }

    .slds-setup-assistant__item {
        border-bottom: none;
    }

    .dashboard-modal {
        min-height: 70%;
    }

    .hide-close /deep/ header button {
        display: none
    }
</style>
